import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

const MAP = {
  succeeded: { dot: "bg-success", text: "text-success", key: "succeeded" },
  valid: { dot: "bg-success", text: "text-success", key: "valid" },
  healthy: { dot: "bg-success", text: "text-success", key: "healthy" },
  running: { dot: "bg-brand animate-pulse", text: "text-brand", key: "running" },
  queued: { dot: "bg-muted-foreground", text: "text-muted-foreground", key: "queued" },
  failed: { dot: "bg-destructive", text: "text-destructive", key: "failed" },
  invalid: { dot: "bg-destructive", text: "text-destructive", key: "invalid" },
  unhealthy: { dot: "bg-destructive", text: "text-destructive", key: "unhealthy" },
  partially_failed: { dot: "bg-warning", text: "text-yellow-700", key: "partial" },
  cancelled: { dot: "bg-muted-foreground", text: "text-muted-foreground", key: "cancelled" },
  untested: { dot: "bg-muted-foreground/50", text: "text-muted-foreground", key: "untested" },
  yes: { dot: "bg-success", text: "text-success", key: "yes" },
  no: { dot: "bg-destructive", text: "text-destructive", key: "no" },
};

export default function StatusBadge({ status, label, testid }) {
  const { t } = useTranslation();
  const cfg = MAP[status] || MAP.untested;
  return (
    <span
      data-testid={testid}
      className={cn("inline-flex items-center gap-1.5 font-mono text-xs uppercase tracking-wide", cfg.text)}
    >
      <span className={cn("h-2 w-2", cfg.dot)} />
      {label || t(`status.${cfg.key}`)}
    </span>
  );
}

export function Bool({ value }) {
  return <StatusBadge status={value ? "yes" : "no"} />;
}
